import './style/index.js';

import _Timeline from './Timeline';
import _TimelineItem from './TimelineItem';

export type { TimelineProps } from './Timeline';
export type { TimelineItemProps } from './TimelineItem';

export const Timeline = _Timeline;
export const TimelineItem = _TimelineItem;

export default Timeline;
